// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "ef26574-dirty",
    "hash": "ef26574",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "ef26574-dirty",
    "semverString": null,
    "frontend": "2.31.7",
    "version": "2.31.7",
    "buildAt": "2025-05-06T07:18:44.146Z",
    "branch": "HEAD"
};
/* tslint:enable */
